import { fetchError, fetchRequest, fetchSuccess, saveRequest, saveSuccess, saveError } from "./actions";
import { fetch, save } from "../../repo/hashedHotCard";
import { isEmpty } from "ramda";
import { isAuthError } from "../index";
import { put, takeEvery, all, spawn, call } from "redux-saga/effects";
import { dirty } from "../session/actions";
import { HashedHotCardActionTypes } from "./types";

// Worker saga for fetching hot cards
function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const hashedHotCard = yield call(fetch, action.payload.id, action.payload.params);
    if (hashedHotCard.errors && !isEmpty(hashedHotCard.errors)) {
      if (isAuthError(hashedHotCard.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(hashedHotCard.errors)));
    } else {
      yield put(fetchSuccess(hashedHotCard));
    }
  } catch (err) {
    yield put(fetchError(err.message || "An error occurred during fetch"));
  }
}

// Worker saga for saving hot cards
function* handleSave(action: ReturnType<typeof saveRequest>) {
  try {
    // @ts-ignore
    const hotcard = yield call(save, action.payload);
    
    if (hotcard.errors && !isEmpty(hotcard.errors)) {
      if (isAuthError(hotcard.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(hotcard.errors)));
      if (action.payload.callback) {
        action.payload.callback(JSON.stringify(hotcard.errors), null);
      }
    } else {
      yield put(saveSuccess(hotcard.data[0]));
      if (action.payload.callback) {
        action.payload.callback(null, hotcard.data[0]);
      }
    }
  } catch (err) {
    yield put(saveError(err.message || "An error occurred while saving Card"));
    if (action.payload.callback) {
      action.payload.callback("An error occurred while saving Card", null);
    }
  }
}

// Watcher saga for fetch requests
function* watchFetchRequest() {
  yield takeEvery(HashedHotCardActionTypes.FETCH, handleFetch);
}

// Watcher saga for save requests
function* watchSaveRequest() {
  yield takeEvery(HashedHotCardActionTypes.SAVE_REQUEST, handleSave);
}

// Root saga for hot cards
export default function* HotCardSaga() {
  yield all([spawn(watchFetchRequest), spawn(watchSaveRequest)]);
}
